import React from 'react'
import { Button, Form, Input, Select, Row, Col, Modal } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx

//经度纬度
import Getlnglat from '@/components/Getlnglat'

import { validatLength, validatLength2, validatePhone, validate } from '@/utils/check'

const UnitInput = ({ title }) => {
  const { UnitStore } = useStore()
  //获得table数据
  // 取消按钮
  const [form] = Form.useForm()
  //经度纬度
  const getGetlnglat = (value) => {
    form.setFieldsValue({
      jd: value[0],
      wd: value[1],
    });
  }
  //点X取消
  const handleOk = () => {
    runInAction(() => {
      set(UnitStore, { isJdWd: false })
    })
  };
  const getAddRole = () => {
    runInAction(() => {
      set(UnitStore, { isJdWd: true })
    })
  }


  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      await UnitStore.getAddButtom(values)
    } else if (title === '编辑') {
      await UnitStore.getPutInformation(values)
    }
    runInAction(() => {
      set(UnitStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{

          }}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(UnitStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(UnitStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="单元编号" name="dybh" rules={[
            {
              required: true,
              message: '请输入单元编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入单元编号" />
          </Form.Item>
          <Form.Item label="单元名称" name="dymc" rules={[
            {
              required: true,
              message: '请输入单元名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入单元名称" />
          </Form.Item>
          <Form.Item label="联系人" name="lxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入联系人名称" />
          </Form.Item>
          <Form.Item label="联系电话" name="lxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入联系电话" />
          </Form.Item>
          <Form.Item label={<div><i style={{ color: 'red' }}>* </i>地理坐标</div>}>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item noStyle name="jd" rules={[
                  { required: true, message: '请输入经度' },
                  {
                    validator: validate
                  }
                ]}>
                  <Input placeholder="经度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item noStyle name="wd"
                  rules={[
                    { required: true, message: '请输入纬度' },
                    {
                      validator: validate
                    }
                  ]}>
                  <Input placeholder="纬度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button type='primary' onClick={getAddRole}>获取坐标</Button>
              </Col>
            </Row>
          </Form.Item>
          <Modal
            title="获取坐标"
            bodyStyle={{ padding: '0' }}
            key={new Date()}
            width="800px"
            open={UnitStore.isJdWd}
            onCancel={handleOk}
            footer={[
              <Button key="submit" type="primary" onClick={handleOk}>
                确认
              </Button>,
            ]}
          >
            <Getlnglat height='600px' value={[UnitStore.valueData.jd, UnitStore.valueData.wd]} onChange={getGetlnglat} />
          </Modal>

          <Form.Item label="单元地址" name="dydz" rules={[
            {
              required: true,
              message: '请输入单元地址',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(UnitStore.valueData)}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(UnitStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(UnitStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="单元编号" name="dybh" rules={[
            {
              required: true,
              message: '请输入单元编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入单元编号" />
          </Form.Item>
          <Form.Item label="单元名称" name="dymc" rules={[
            {
              required: true,
              message: '请输入单元名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入单元名称" />
          </Form.Item>
          <Form.Item label="联系人" name="lxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入联系人名称" />
          </Form.Item>
          <Form.Item label="联系电话" name="lxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入联系电话" />
          </Form.Item>
          <Form.Item label={<div><i style={{ color: 'red' }}>* </i>地理坐标</div>}>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item noStyle name="jd" rules={[
                  { required: true, message: '请输入经度' },
                  {
                    validator: validate
                  }
                ]}>
                  <Input placeholder="经度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item noStyle name="wd"
                  rules={[
                    { required: true, message: '请输入纬度' },
                    {
                      validator: validate
                    }
                  ]}>
                  <Input placeholder="纬度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button type='primary' onClick={getAddRole}>获取坐标</Button>
              </Col>
            </Row>
          </Form.Item>
          <Modal
            title="获取坐标"
            bodyStyle={{ padding: '0' }}
            key={new Date()}
            width="800px"
            open={UnitStore.isJdWd}
            onCancel={handleOk}
            footer={[
              <Button key="submit" type="primary" onClick={handleOk}>
                确认
              </Button>,
            ]}
          >
            <Getlnglat height='600px' value={[UnitStore.valueData.jd, UnitStore.valueData.wd]} onChange={getGetlnglat} />
          </Modal>

          <Form.Item label="单元地址" name="dydz" rules={[
            {
              required: true,
              message: '请输入单元地址',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '查看' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(UnitStore.valueData)}
        >
          <Form.Item label="所属系统" >
            {UnitStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="所属企业" >
            {UnitStore.valueData.qymc}
          </Form.Item>
          <Form.Item label="单元编号" >
            {UnitStore.valueData.dybh}
          </Form.Item>
          <Form.Item label="单元名称" >
            {UnitStore.valueData.dymc}
          </Form.Item>
          <Form.Item label="联系人" >
            {UnitStore.valueData.lxr}
          </Form.Item>
          <Form.Item label="联系电话" >
            {UnitStore.valueData.lxdh}
          </Form.Item>
          <Form.Item label="地理坐标" >
            {UnitStore.valueData.jd}-{UnitStore.valueData.wd}
          </Form.Item>
          <Form.Item label="单元地址" >
            {UnitStore.valueData.dydz}
          </Form.Item>
          <Form.Item label="备注信息" >
            {UnitStore.valueData.bz}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(UnitInput)